// Albanian translations
export const sq: Record<string, string> = {
  'menu.dashboard': 'Paneli',
  'menu.customers': 'Klientët',
  'menu.products': 'Produktet',
  'menu.users': 'Përdoruesit',
  'menu.settings': 'Cilësimet',
  'menu.logout': 'Dil',
  'dashboard.title': 'Paneli',
  'dashboard.newOrder': 'Porosi e re',
  'order.title': 'Porosi e re',
  'order.customer': 'Klienti',
  'order.products': 'Produktet',
  'order.total': 'Totali',
  'users.title': 'Përdoruesit',
  'users.name': 'Emri',
  'users.email': 'Email',
  'common.yes': 'Po',
  'common.no': 'Jo',
  'common.cancel': 'Anulo',
  'common.save': 'Ruaj',
  'common.search': 'Kërko',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Hyr',
  'login.welcome': 'Mirë se vini, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Telefoni',
  'menu.reportsAndAccounting': 'Raporte & Kontabilitet',
  'menu.systemAndCommunication': 'Sistemi & Komunikimi',
};